"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _scrollIntoViewIfNeeded = _interopRequireDefault(require("scroll-into-view-if-needed"));
var _reactCreateRef = _interopRequireDefault(require("react-create-ref"));
var _requestAnimationFrameTimeout = require("request-animation-frame-timeout");
var _Close = _interopRequireWildcard(require("./Close"));
var _OnFocusOutOrTapOutside = _interopRequireDefault(require("./OnFocusOutOrTapOutside"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } // For some weird reason, in Chrome, `setTimeout()` would lag up to a second (or more) behind.
// Turns out, Chrome developers have deprecated `setTimeout()` API entirely without asking anyone.
// Replacing `setTimeout()` with `requestAnimationFrame()` can work around that Chrome bug.
// https://github.com/bvaughn/react-virtualized/issues/722
// `PureComponent` is only available in React >= 15.3.0.
var PureComponent = _react["default"].PureComponent || _react["default"].Component;

/**
 * Usage:
 *
 * <button onClick={() => this.expandable.toggle()}>
 *   Toggle
 * </button>
 *
 * <Expandable ref={ref => this.expandable = ref}>
 *   ...
 * </Expandable>
 *
 * Methods:
 * * `.toggle()`
 * * `.expand()`
 * * `.collapse()`
 * * `.isExpanded()`
 */
var Expandable = /*#__PURE__*/function (_PureComponent) {
  _inherits(Expandable, _PureComponent);
  var _super = _createSuper(Expandable);
  function Expandable() {
    var _this;
    _classCallCheck(this, Expandable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      // Initializing it to `false` is required for `if (expand === expanded)`.
      expanded: false
    });
    _defineProperty(_assertThisInitialized(_this), "onFocusOutRef", (0, _reactCreateRef["default"])());
    _defineProperty(_assertThisInitialized(_this), "isExpanded", function () {
      return _this.state.expanded;
    });
    // Returns a `Promise`.
    _defineProperty(_assertThisInitialized(_this), "expand", function (parameters) {
      return _this.toggle(true, parameters);
    });
    // Returns a `Promise`.
    _defineProperty(_assertThisInitialized(_this), "collapse", function () {
      return _this.toggle(false);
    });
    // Returns a `Promise`.
    _defineProperty(_assertThisInitialized(_this), "toggle", function (expand) {
      var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // This code is also copy-pasted in `source/SlideOutMenu.js`.

      var _this$props = _this.props,
        onExpand = _this$props.onExpand,
        onExpanded = _this$props.onExpanded,
        onCollapse = _this$props.onCollapse,
        onCollapsed = _this$props.onCollapsed;
      var expanded = _this.state.expanded;

      // If no `expand` argument provided then just toggle.
      var isExpandedState = expanded && _this.process !== 'unexpand' || _this.process === 'expand';
      if (expand === undefined) {
        expand = !isExpandedState;
      }

      // Don't collapse if already collapsed.
      // Don't expand if already expanded
      // unless manually forcing a refresh of content.

      var refreshingExpanded;
      if (expand && isExpandedState && parameters.refresh) {
        refreshingExpanded = true;
      }
      if (expand === isExpandedState && !refreshingExpanded) {
        return Promise.resolve();
      }

      // if (this.isToggling && !refreshingExpanded) {
      // 	return Promise.resolve()
      // }

      if (_this.cancelProcess) {
        _this.cancelProcess();
      }
      var cancelled;
      var reset = function reset() {
        _this.process = undefined;
        _this.processPhase = undefined;
        _this.cancelProcess = undefined;
      };
      var nextPhase = function nextPhase(phase) {
        if (!cancelled) {
          _this.processPhase = phase;
          return true;
        }
      };
      function endProcess() {
        nextPhase();
        reset();
      }
      var phaseCancellers = {};
      function onCancelPhase(phase, handler) {
        phaseCancellers[phase] = handler;
      }
      _this.cancelProcess = function () {
        if (phaseCancellers[_this.processPhase]) {
          phaseCancellers[_this.processPhase]();
        }
        cancelled = true;
        reset();
      };
      if (expand) {
        // Expand.
        _this.process = 'expand';
        onCancelPhase('scheduleExpand', function () {
          return (0, _requestAnimationFrameTimeout.clearTimeout)(_this.expandTimeout);
        });
        onCancelPhase('expanded', function () {
          return (0, _requestAnimationFrameTimeout.clearTimeout)(_this.scrollIntoViewTimer);
        });
        nextPhase('preload');
        return _this.preload().then(function () {
          return new Promise(function (resolve) {
            if (!nextPhase('render')) {
              return;
            }
            _this.setState({
              shouldRender: true
            },
            // Without an artificial delay for some reason the CSS "expand" animation won't play.
            // Perhaps a browser decides to optimize two subsequent renders
            // and doesn't render "pre-expanded" and "expanded" states separately.
            // Even with a 0ms delay it would randomly play/not-play the expand animation.
            function () {
              if (!nextPhase('scheduleExpand')) {
                return;
              }
              if (onExpand) {
                onExpand();
              }
              // Using `requestAnimationFrame()` instead of `setTimeout()`
              // because otherwise there would be a weird and strange delay.
              _this.expandTimeout = (0, _requestAnimationFrameTimeout.setTimeout)(function () {
                if (!nextPhase('expand')) {
                  return;
                }
                _this.expandTimeout = undefined;
                _this.setState({
                  expanded: true
                }, function () {
                  if (!nextPhase('expanded')) {
                    return;
                  }
                  if (onExpanded) {
                    onExpanded();
                  }
                  if (_this.onFocusOutRef.current) {
                    _this.onFocusOutRef.current.listenToTouches();
                  }
                  _this.scrollIntoView().then(endProcess);
                  // `resolve()` doesn't wait for `scrollIntoView`
                  // because other components use it like `.toggle().then(focus)`
                  // where it shouldn't wait for the final phases like "scroll into view".
                  resolve();
                });
              }, 0);
            });
          });
        });
      } else {
        // Un-Expand.
        _this.process = 'unexpand';
        onCancelPhase('unexpand', function () {
          return (0, _requestAnimationFrameTimeout.clearTimeout)(_this.scrollIntoViewTimer);
        });
        onCancelPhase('unexpanded', function () {
          return (0, _requestAnimationFrameTimeout.clearTimeout)(_this.waitUnForExpandAnimationTimer);
        });
        nextPhase('unexpand');
        if (_this.onFocusOutRef.current) {
          _this.onFocusOutRef.current.stopListeningToTouches();
        }
        if (onCollapse) {
          onCollapse({
            focusOut: _this.focusOut
          });
        }
        // Set `expanded` to `false` to play the collapse CSS animation.
        // Once that animation is finished remove
        // the contents of the `<Expanded/>` from DOM.
        return new Promise(function (resolve) {
          _this.setState({
            expanded: false
          }, function () {
            if (!nextPhase('unexpanded')) {
              return;
            }
            if (onCollapsed) {
              onCollapsed();
            }
            var waitForUnExpandAnimation = function waitForUnExpandAnimation() {
              var expandAnimationDuration = _this.props.expandAnimationDuration;
              return new Promise(function (resolve) {
                _this.waitUnForExpandAnimationTimer = (0, _requestAnimationFrameTimeout.setTimeout)(resolve, expandAnimationDuration * 1.1);
              });
            };
            waitForUnExpandAnimation().then(function () {
              if (!nextPhase('unrender')) {
                return;
              }
              _this.setState({
                shouldRender: false
              }, endProcess);
            });
            // `resolve()` doesn't wait for `removeFromDOMAfterCollapsed`
            // because other components use it like `.toggle().then(focus)`
            // where it shouldn't wait for the final phases like "scroll into view".
            resolve();
          });
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
      if (event.defaultPrevented) {
        return;
      }
      if (event.ctrlKey || event.altKey || event.shiftKey || event.metaKey) {
        return;
      }
      switch (event.keyCode) {
        // Collapse on "Escape".
        case 27:
          event.preventDefault();
          // Collapse the list if it's expanded
          return _this.collapse();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "storeContainerNode", function (node) {
      return _this.container = node;
    });
    _defineProperty(_assertThisInitialized(_this), "getContainerNode", function () {
      return _this.container;
    });
    // This function is called from outside in `<ExpandableList/>`.
    _defineProperty(_assertThisInitialized(_this), "onBlur", function (event) {
      if (_this.onFocusOutRef.current) {
        _this.onFocusOutRef.current.onBlur(event);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onFocusOut", function (event) {
      // In some scenarios, selecting a value in a `<Select/>` may hide that select.
      // In that case, it won't be mounted anymore, so it won't make any difference
      // whether its `onFocusOut()` handler is called or not because it's UI-related
      // and `onChange()` has already been processed.
      if (_this._isBeingUnmounted) {
        return;
      }
      var onFocusOut = _this.props.onFocusOut;
      _this.focusOut = true;
      onFocusOut(event);
      _this.focusOut = undefined;
    });
    return _this;
  }
  _createClass(Expandable, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isBeingUnmounted = true;
      if (this.cancelProcess) {
        this.cancelProcess();
      }
    }
  }, {
    key: "preload",
    value:
    // Preload `<Expanded/>` content (if required).
    // Returns a `Promise`.
    function preload() {
      var _this2 = this;
      var _this$props2 = this.props,
        preload = _this$props2.preload,
        onPreloadStateChange = _this$props2.onPreloadStateChange;
      if (preload) {
        this.setState({
          isPreloading: true
        });
        if (onPreloadStateChange) {
          onPreloadStateChange(true);
        }
      }
      return (preload ? preload() : Promise.resolve()).then(function () {
        if (onPreloadStateChange) {
          onPreloadStateChange(false);
        }
        _this2.setState({
          isPreloading: false
        });
      }, function (error) {
        console.error(error);
        // if (onPreloadError) {
        // 	onPreloadError(error)
        // }
        if (onPreloadStateChange) {
          onPreloadStateChange(false);
        }
        _this2.setState({
          isPreloading: false
        });
      });
    }
  }, {
    key: "scrollIntoView",
    value: function scrollIntoView() {
      var _this3 = this;
      var _this$props3 = this.props,
        shouldScrollIntoView = _this$props3.scrollIntoView,
        scrollIntoViewDelay = _this$props3.scrollIntoViewDelay,
        expandAnimationDuration = _this$props3.expandAnimationDuration;
      if (!shouldScrollIntoView) {
        return Promise.resolve();
      }
      return new Promise(function (resolve) {
        _this3.scrollIntoViewTimer = (0, _requestAnimationFrameTimeout.setTimeout)(function () {
          // https://github.com/stipsan/scroll-into-view-if-needed/issues/359
          // scrollIntoView(this.container, false, { duration: 300 })
          (0, _scrollIntoViewIfNeeded["default"])(_this3.container, {
            scrollMode: 'if-needed',
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
          });
          resolve();
        }, Math.max(scrollIntoViewDelay, expandAnimationDuration) * 1.1);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        animation = _this$props4.animation,
        alignment = _this$props4.alignment,
        upward = _this$props4.upward,
        onFocusOut = _this$props4.onFocusOut,
        getTogglerNode = _this$props4.getTogglerNode,
        closeLabel = _this$props4.closeLabel,
        CloseButtonIcon = _this$props4.closeButtonIcon,
        role = _this$props4.role,
        style = _this$props4.style,
        className = _this$props4.className,
        children = _this$props4.children;
      var _this$state = this.state,
        shouldRender = _this$state.shouldRender,
        expanded = _this$state.expanded;
      if (!shouldRender) {
        return null;
      }

      // `tabIndex={-1}` was prevously used to make the `<div/>` focusable,
      // so that `<Expandable/>` didn't collapse on a click somewhere inside it
      // when the click didn't focus some `<button/>` inside it but rather
      // was pointed at a non-interactive space inside it (for example, top or bottom padding).
      //
      // But then, in Dec 2018, that workaround was removed:
      // https://github.com/catamphetamine/react-responsive-ui/commit/569a7f9ab725787e1b6c4c8e16183e15865da06b
      //
      // Currently, that workaround doesn't seem to be required and, for example,
      // an `<ExpandableMenu/>` doesn't close when clicking on a non-interactive part of it.

      // It doesn't set `aria-hidden={true/false}` property on the `<div/>`.
      // The rationale is that when `<Expandable/>` is collapsed, the `<div/>` is not rendered.

      var element = /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.storeContainerNode,
        onKeyDown: this.onKeyDown,
        role: role,
        "aria-hidden": this.props['aria-hidden'],
        "aria-label": this.props['aria-label'],
        style: style,
        className: (0, _classnames["default"])(className, 'rrui__shadow', 'rrui__expandable', 'rrui__expandable--overlay', animation && "rrui__expandable--".concat(animation), animation && expanded && "rrui__expandable--expanded--".concat(animation), {
          'rrui__expandable--expanded': expanded,
          'rrui__expandable--left-aligned': alignment === 'left',
          'rrui__expandable--right-aligned': alignment === 'right',
          'rrui__expandable--upward': upward,
          'rrui__expandable--downward': !upward
        })
      }, _react["default"].Children.map(children, function (child) {
        return /*#__PURE__*/_react["default"].cloneElement(child, {
          className: (0, _classnames["default"])(child.props.className, 'rrui__expandable__content', animation && "rrui__expandable__content--".concat(animation), {
            'rrui__expandable__content--expanded': expanded
          })
        });
      }), expanded && CloseButtonIcon && /*#__PURE__*/_react["default"].createElement(_Close["default"], {
        onClick: this.collapse,
        closeLabel: closeLabel,
        className: (0, _classnames["default"])('rrui__close--bottom-right', 'rrui__expandable__close')
      }, /*#__PURE__*/_react["default"].createElement(CloseButtonIcon, null)));
      if (onFocusOut) {
        // `<OnFocusOutOrTapOutside/>` sets `onBlur` on the `<div/>`.
        // `<Expandable/>` calls `.listenToTouches()` / `.stopListeningToTouches()` manually.
        element = /*#__PURE__*/_react["default"].createElement(_OnFocusOutOrTapOutside["default"], {
          ref: this.onFocusOutRef,
          getContainerNode: this.getContainerNode,
          getTogglerNode: getTogglerNode,
          onFocusOut: this.onFocusOut,
          listenToTouches: false
        }, element);
      }
      return element;
    }
  }]);
  return Expandable;
}(PureComponent);
exports["default"] = Expandable;
_defineProperty(Expandable, "propTypes", {
  // The default animation could be called "expand".
  animation: _propTypes["default"].oneOf(['fade-up']),
  // Can optionally preload `<Expandable/>` contents before expanding it.
  // Must return a `Promise`.
  preload: _propTypes["default"].func,
  onPreloadStateChange: _propTypes["default"].func,
  onPreloadError: _propTypes["default"].func,
  onExpand: _propTypes["default"].func,
  onCollapse: _propTypes["default"].func,
  // Whether the `<Expandable/>` expands upwards or downwards.
  alignment: _propTypes["default"].oneOf(['left', 'right']),
  // If this flag is set to `true`,
  // then the dropdown expands itself upward.
  // (as opposed to the default downward)
  upward: _propTypes["default"].bool,
  // ARIA `role` (accessibility).
  role: _propTypes["default"].string,
  // CSS style object.
  style: _propTypes["default"].object,
  // CSS class.
  className: _propTypes["default"].string,
  // When the `<Expandable/>` is expanded
  // its content may not fit on the screen.
  // If `scrollIntoView` is `true` (which is the default)
  // then the browser will automatically scroll
  // so that the expanded content fits on the screen.
  scrollIntoView: _propTypes["default"].bool,
  // If `scrollIntoView` is `true` (which is the default)
  // then these two are gonna define the delay after which it scrolls into view.
  expandAnimationDuration: _propTypes["default"].number,
  scrollIntoViewDelay: _propTypes["default"].number,
  getTogglerNode: _propTypes["default"].func,
  onFocusOut: _propTypes["default"].func,
  // `aria-label` for the "Close" button
  // (which is an "x" visible in fullscreen mode).
  closeLabel: _propTypes["default"].string,
  // The "x" button icon that closes the `<Select/>`
  // in fullscreen mode on mobile devices.
  closeButtonIcon: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].oneOf([false])])
});
_defineProperty(Expandable, "defaultProps", {
  scrollIntoView: true,
  expandAnimationDuration: 150,
  scrollIntoViewDelay: 0,
  // The "x" button icon that closes the `<Select/>`
  // in fullscreen mode on mobile devices.
  closeButtonIcon: _Close.CloseIcon
});
//# sourceMappingURL=Expandable.js.map